import { parseNumber } from './commonHelpers'

export function calculate (creditLimit, listingUuid, bidValue) {
  // console.log('>>>! Calculating credit limit:', { creditLimit, listingUuid, bidValue })
  const creditLimitBids = { ...creditLimit.bids }
  const creditLimitMaxBids = { ...creditLimit.maxBids }

  // if (creditLimitBids?.[listingUuid] && bidValue) {
  if (bidValue && listingUuid) {
    creditLimitBids[listingUuid] = bidValue
    console.log('>>>! Calculating credit limit AGAIN:', { creditLimit, listingUuid, bidValue })
  }
  const currentSpend = Object.values(creditLimitBids).reduce((total, bid) => parseNumber(total) + parseNumber(bid), 0)

  Object.entries(creditLimitMaxBids).forEach(([listingUuid, maxBid]) => {
    if (maxBid > creditLimitBids?.[listingUuid]) {
      creditLimitBids[listingUuid] = maxBid
    }
  })

  const maxBidSpend = Object.values(creditLimitBids).reduce((total, bid) => parseNumber(total) + parseNumber(bid), 0)

  return {
    biddingStatus: creditLimit.maxSpend < 1 || maxBidSpend > creditLimit.maxSpend ? 'overdrawn' : 'valid',
    maxSpend: creditLimit.maxSpend,
    currentSpend: currentSpend,
    maxBidSpend
  }
}

const creditLimit = {
  calculate
}

export default creditLimit
